var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKingCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 12C21.5 7.03005 17.4709 3 12.5 3C7.52908 3 3.5 7.03005 3.5 12C3.5 16.9709 7.52908 21 12.5 21C17.4709 21 21.5 16.9709 21.5 12Z",
    stroke: "#596BD7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.3334 9.81755C15.698 10.3322 14.9109 10.9695 14.5723 11.2439C14.4828 11.3169 14.3524 11.3072 14.2755 11.2206C13.9272 10.8294 13.0282 9.81852 12.6604 9.405C12.5738 9.30771 12.4249 9.30771 12.3383 9.405C11.9706 9.81852 11.0715 10.8294 10.7232 11.2206C10.6463 11.3072 10.516 11.3169 10.4265 11.2439C10.0879 10.9695 9.30073 10.3322 8.66538 9.81755C8.5097 9.69106 8.28008 9.82436 8.31511 10.0219C8.49316 11.0299 8.85997 13.112 9.03608 14.1113C9.09251 14.4362 9.37467 14.6707 9.70451 14.6707H15.2962C15.626 14.6707 15.9082 14.4362 15.9646 14.1113C16.1407 13.1111 16.5066 11.0289 16.6836 10.0209C16.7187 9.82338 16.4891 9.69106 16.3334 9.81755Z",
    stroke: "#596BD7",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKingCircle);
export default __webpack_public_path__ + "static/media/king-circle.e5083449813412151c15fae6852bbc71.svg";
export { ForwardRef as ReactComponent };